import { render, staticRenderFns } from "./MedisGs1Details.vue?vue&type=template&id=a952b664&"
import script from "./MedisGs1Details.vue?vue&type=script&lang=ts&"
export * from "./MedisGs1Details.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports